import * as React from "react"
import Helmet from "react-helmet"
import Layout from "../components/Layout/Layout"
import Title from "../components/Title/Title"
import BreadcrumbBar from "../components/BreadcrumbBar/BreadcrumbBar"

function Appointments() {
    const parentPages = [{name: "Home", path: "/"}]

    return (
        <Layout>
            <Helmet>

            </Helmet>
            <Title title="Book an Appointment" />
            <BreadcrumbBar currentPage="Appointments" parentPages={parentPages} />
        </Layout>
    )
}

export default Appointments